import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useHistory, Link, useParams } from "react-router-dom";
import { XCircle, Save } from "react-feather";
import { GET, POST, PUT } from "../../../api/adminApi";

export default function LevelCreate() {
  const { id } = useParams();
  const history = useHistory();

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      level: "",
      minPoints: "",
      maxPoints: "",
    },
  });

  const onSubmit = async (data) => {
    let payload;
    if (id) {
      payload = {
        level: parseInt(id),
        minPoints: parseInt(data.minPoints),
        maxPoints: parseInt(data.maxPoints),
      };
    } else {
      payload = {
        level: parseInt(data.level),
        minPoints: parseInt(data.minPoints),
        maxPoints: parseInt(data.maxPoints),
      };
    }

    // if (!payload.minPoints || !payload.maxPoints) {
    //   toast.error("Минимум и Максимум обязательны");
    //   return;
    // }
    //
    // if (payload.minPoints > payload.maxPoints) {
    //   toast.error("Минимум не может быть больше Максимума");
    //   return;
    // }

    if (id) {
      const response = await PUT(`/services/admin/api/level`, payload);
      if (response?.success) {
        // toast.success("Изменения успешно сохранены");
        history.push("/admin/level");
      }
    } else {
      const response = await POST("/services/admin/api/level", payload);
      if (response?.success) {
        // toast.success("Уровень успешно создан");
        history.push("/admin/level");
      }
    }
  };

  const getData = async () => {
    const response = await GET(`/services/admin/api/level/${id}`);
    if (response) {
      setValue("minPoints", response.minPoints);
      setValue("maxPoints", response.maxPoints);
    }
  };

  useEffect(() => {
    if (id) {
      getData();
    } else {
      reset();
    }
  }, [id]);

  return (
    <div className="mb-1 mx-3">
      <h3 className="mb-5 mt-5">
        {id ? "Редактировать уровень" : "Создать уровень"}
      </h3>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <div
          className="admin-card p-4 pt-12 d-flex flex-column "
          style={{ height: "70vh" }}
        >
          {/* Level */}
          {!id && (
            <div className="d-flex align-items-center mb-2 gap-2">
              <label
                style={{ width: "120px" }}
                className="color-grey text-end text-nowrap"
              >
                Уровень
              </label>
              <div>
                <input
                  type="number"
                  className="input-control"
                  style={{ width: "300px" }}
                  placeholder="Введите уровень"
                  {...register("level", {
                    required: "Уровень обязательное поле",
                  })}
                />
                {errors.level && (
                  <span className="text-danger ml-2">
                    {errors.level.message}
                  </span>
                )}
              </div>
            </div>
          )}

          {/* Minimum Points */}
          <div className="d-flex align-items-center mb-2 gap-2">
            <label
              style={{ width: "120px" }}
              className="color-grey text-end text-nowrap"
            >
              Минимум
            </label>
            <div>
              <input
                type="number"
                className="input-control"
                style={{ width: "300px" }}
                placeholder="Введите минимум"
                {...register("minPoints", {
                  required: "Минимум обязательное поле",
                })}
              />
              {errors.minPoints && (
                <span className="text-danger ml-2">
                  {errors.minPoints.message}
                </span>
              )}
            </div>
          </div>

          {/* Maximum Points */}
          <div className="d-flex align-items-center mb-2 gap-2">
            <label
              style={{ width: "120px" }}
              className="color-grey text-end text-nowrap"
            >
              Максимум
            </label>
            <div>
              <input
                type="number"
                className="input-control"
                style={{ width: "300px" }}
                placeholder="Введите максимум"
                {...register("maxPoints", {
                  required: "Максимум обязательное поле",
                })}
              />
              {errors.maxPoints && (
                <span className="text-danger ml-2">
                  {errors.maxPoints.message}
                </span>
              )}
            </div>
          </div>

          <div className="d-flex justify-content-end">
            <Link to="/admin/level" className="mr-3">
              <button className="btn text-white btn-bg-primary d-flex align-items-center">
                <XCircle size={14} className="mr-2" />
                Отмена
              </button>
            </Link>
            <button
              className="btn text-white btn-bg-success d-flex align-items-center"
              type="submit"
            >
              <Save size={14} className="mr-2" />
              Сохранить
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
